import { WeixinCoupon } from '@/api/index'

export function get_WeixinCouponSet (data) {
  return WeixinCoupon.request({
    url: '/get_WeixinCouponSet',
    method: 'post',
    data,
    iSFromData: true
  })
}
export function SaveWeixinCouponSet (data) {
  return WeixinCoupon.request({
    url: '/SaveWeixinCouponSet',
    method: 'post',
    data,
    iSFromData: true
  })
}
export function DeleteWeixinCouponSet (data) {
  return WeixinCoupon.request({
    url: '/DeleteWeixinCouponSet',
    method: 'post',
    data,
    iSFromData: true
  })
}
export function get_WeixinCoupon (data) {
  return WeixinCoupon.request({
    url: '/get_WeixinCoupon',
    method: 'post',
    data,
    iSFromData: true
  })
}
